import React from "react";
import SearchIcon from "@material-ui/icons/Search";

const SearchBar = ({ onSearch }) => {
  return (
    <div className="search-bar">
      <SearchIcon />
      <input
        type="text"
        placeholder="Search"
        onChange={(e) => onSearch(e.target.value)}
      />
    </div>
  );
};

export default SearchBar;
